import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";

interface PhoneData {
  value?: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
}

const onlyNumber = (str: string) => str.replace(/[^0-9]/gu, "");

const PhoneMask: React.FC<PhoneData> = ({ value, onChange, onBlur, style }) => {
  const safeValue = typeof value === "string" ? value : "";
  const [autoPrefix, setAutoPrefix] = useState(true);

  useEffect(() => {
    if (!safeValue) {
      setAutoPrefix(true);
      return;
    }

    setAutoPrefix(safeValue.startsWith("55"));
  }, [safeValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = onlyNumber(e.target.value);
    setAutoPrefix(numericValue.startsWith("55") || numericValue === "");

    onChange({
      ...e,
      target: {
        ...e.target,
        value: numericValue
      }
    });
  };

  return (
    <InputMask
      mask={autoPrefix ? "+99 (99) 9 9999-9999" : ""}
      value={safeValue}
      onChange={handleChange}
      onBlur={onBlur}
      style={style}
      placeholder={"+55 (__) _ ____-____"}
    />
  );
};

export default PhoneMask;
